var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { nanoid } from "nanoid";
import { createEvent, createStore } from "effector";
export var removeNotification = createEvent();
export var notify = createEvent();
export var $notifications = createStore([]);
$notifications
    .on(removeNotification, function (xs, key) { return xs.filter(function (x) { return x.id !== key; }); })
    .on(notify, function (state, payload) {
    return state.concat({
        id: nanoid(),
        message: payload.message,
        options: __assign(__assign({}, payload.options), { variant: payload.variant }),
    });
});
